import { render, staticRenderFns } from "./ProductOffers.vue?vue&type=template&id=7317422a&scoped=true&name=product-offers&"
import script from "./ProductOffers.vue?vue&type=script&lang=js&"
export * from "./ProductOffers.vue?vue&type=script&lang=js&"
import style0 from "./ProductOffers.vue?vue&type=style&index=0&id=7317422a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7317422a",
  null
  
)

/* custom blocks */
import block0 from "./ProductOffers.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports